import { render } from "./SobreImc.vue?vue&type=template&id=97520628"
import script from "./SobreImc.vue?vue&type=script&lang=js"
export * from "./SobreImc.vue?vue&type=script&lang=js"

import "./SobreImc.vue?vue&type=style&index=0&id=97520628&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__